document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.tableau-comparatif');
  if (!section) return;

  const container = section.querySelector('.tableau-comparatif-container');
  const overlay = container?.querySelector('.tableau-comparatif-video-overlay');
  if (!container || !overlay) return;

  function positionOverlay() {
    const imagesRow = container.querySelector('.tableau-comparatif-images');
    const namesRow = container.querySelector('.tableau-comparatif-header');
    if (!imagesRow || !namesRow) return;

    // Mesurer la première colonne produit en fonction du layout courant
    // On récupère la première cellule produit dans la rangée des noms
    const firstProductCell = namesRow.querySelector('.tableau-comparatif-product');
    if (!firstProductCell) return;

    const containerRect = container.getBoundingClientRect();
    const productRect = firstProductCell.getBoundingClientRect();

    const left = productRect.left - containerRect.left + container.scrollLeft;
    const width = productRect.width;

    // Hauteur: couvrir toute la zone bleue (du header noms jusqu'à la dernière ligne)
    const containerRect2 = container.getBoundingClientRect();
    const headerRect = namesRow.getBoundingClientRect();
    const lastRow = container.querySelector('.tableau-comparatif-row:last-of-type');
    const lastRect = lastRow ? lastRow.getBoundingClientRect() : headerRect;
    const topOffset = headerRect.top - containerRect2.top + container.scrollTop;
    const height = lastRect.bottom - headerRect.top;

    overlay.style.left = `${left}px`;
    overlay.style.top = `${topOffset}px`;
    overlay.style.width = `${width}px`;
    overlay.style.height = `${height}px`;
  }

  positionOverlay();
  window.addEventListener('resize', positionOverlay);
  // si images chargées modifient le layout
  window.addEventListener('load', positionOverlay);
});

